import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ReactComponent as QontactPointSVG } from '@assets/SVGs/QontactPoint/QontactPointSVG.svg';
import { TabDetailScreenWrapper } from '@components/General/TabDetailScreen';
import QontactPointInformacionTab from './Informacion/QontactPointInformacionTab';
import { useQRMode } from '@hooks/useQRMode';
import QontactPointTurnos from '@components/QontactPoints/Turnos/QontactPointTurnos';
import QontactPointTurnosTab from './Turnos/QontactPointTurnosTab';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import { QontactPointInformation } from '@models/QontactPoint';
import QontactPointFichajesTab from './Fichajes/QontactPointFichajesTab';

interface QontactPointDetailScreenProps {
    org: Organization;
}

const QontactPointDetailScreen: React.FC<QontactPointDetailScreenProps> = ({org}) => {

    const location = useLocation();
    // Which QR to show depends on the organization's check-in channel
    const qrMode = useQRMode(org);
    const qontactPointRaw = location.state?.qontactPoint as QontactPointInformation | undefined;

    const [clickedScreen, setClickedScreen] = useState<string>(location.state?.defaultScreen || "editar")
    const [qontactPoint, setQontactPoint] = useState<QontactPointInformation | null>(qontactPointRaw ?? null);

    useEffect(() => {
        if (qontactPointRaw) {
            setQontactPoint(qontactPointRaw);
        }
    }, [qontactPointRaw]);

    if (qontactPoint === null) {
        return <div></div>
    }

    const oldShiftFlaps: Flap[] = [
        {
            id: 'turnos',
            label: 'Turnos',
            content: <QontactPointTurnos orgID={org.id} qontactPoint={qontactPoint}/>,
            isLocked: org.newFlags?.LiteVersion
        },
    ]

    const shiftsV2Flaps: Flap[] = [
        {
            id: 'turnos',
            label: 'Turnos',
            content: <QontactPointTurnosTab orgID={org.id} qontactPoint={qontactPoint}/>,
            isLocked: org.newFlags?.LiteVersion
        },
    ]

    const flaps: Flap[] = [
        {
            // id kept as "editar": the list's edit action opens this tab by that id
            id: 'editar',
            label: 'Información',
            content: (
                <QontactPointInformacionTab
                    orgID={org.id}
                    qontactPoint={qontactPoint}
                    setQontactPoint={setQontactPoint}
                    qrMode={qrMode}
                />
            )
        },
        ...org.newFlags?.PresenteeismShiftsV2 ? shiftsV2Flaps : oldShiftFlaps,
        {
            id: 'reporte',
            label: 'Fichajes',
            content: (
                <QontactPointFichajesTab
                    orgID={org.id}
                    qontactPoint={qontactPoint}
                    shouldShowMonthlyAttendanceSheetExport={Boolean(org.newFlags?.QontactPointMonthlyAttendancePdf)}
                    onOpenShifts={org.newFlags?.LiteVersion ? undefined : () => setClickedScreen('turnos')}
                />
            ),
            isLocked: org.newFlags?.LiteVersion
        }
    ];

    return (
        <TabDetailScreenWrapper
            title={qontactPoint ? qontactPoint.name : "Qontact Point"}
            imgComponent={<QontactPointSVG />}
            flaps={flaps}
            flag={org.newFlags?.QontactPointCreationWeb}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );

};


export default QontactPointDetailScreen
